export type BeerReviewConsumptionPlaceFilter =
  | 'all'
  | 'thisLocation'
  | 'home'
  | 'venue'
  | 'event';

export interface BeerReviewConsumptionPlaceRow {
  consumptionPlaceType?: string;
  consumptionPlaceId?: string;
}

export const BEER_REVIEW_CONSUMPTION_PLACE_FILTER_OPTIONS: Array<{
  value: BeerReviewConsumptionPlaceFilter;
  label: string;
}> = [
  { value: 'all', label: 'All places' },
  { value: 'thisLocation', label: 'Brewery' },
  { value: 'venue', label: 'Venue' },
  { value: 'event', label: 'Event' },
  { value: 'home', label: 'Home' },
];

function matchesThisLocationReview(
  review: BeerReviewConsumptionPlaceRow,
  activeBreweryId: string,
): boolean {
  if (review.consumptionPlaceType !== 'brewery') {
    return false;
  }
  const consumptionPlaceId =
    typeof review.consumptionPlaceId === 'string'
      ? review.consumptionPlaceId.trim()
      : '';
  if (!consumptionPlaceId) {
    return false;
  }
  return consumptionPlaceId === activeBreweryId;
}

/**
 * Filters loaded beer reviews by consumption place in memory.
 */
export function filterBeerReviewsByConsumptionPlace<T extends BeerReviewConsumptionPlaceRow>(
  reviews: T[],
  filterValue: BeerReviewConsumptionPlaceFilter,
  activeBreweryId = '',
): T[] {
  if (!Array.isArray(reviews)) {
    return [];
  }
  if (filterValue === 'all') {
    return reviews;
  }

  if (filterValue === 'thisLocation') {
    const normalizedActiveId =
      typeof activeBreweryId === 'string' ? activeBreweryId.trim() : '';
    if (!normalizedActiveId) {
      return [];
    }
    return reviews.filter((review) =>
      matchesThisLocationReview(review, normalizedActiveId),
    );
  }

  return reviews.filter((review) => review?.consumptionPlaceType === filterValue);
}
